import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Page, PageHeader } from "../../../components/ui";
import { addGenre } from "../../../services/genres";
import GenreForm, { initialRows } from "./GenreForm";

/** Creates one genre per enabled content type, one after the other. */
export async function createGenres(name, rows) {
  for (const row of rows.filter((r) => r.is_enabled)) {
    await addGenre({
      name,
      type: row.type,
      imageBase64: row.imageBase64,
      is_enabled: true,
    });
  }
}

const AddGenre = () => {
  const { t } = useTranslation();
  // Remounting the form clears it after a successful creation.
  const [formKey, setFormKey] = useState(0);

  const handleSubmit = async (name, rows) => {
    try {
      await createGenres(name, rows);
      toast.success(t("Genre created successfully!"), {
        progressStyle: { background: "var(--iq-primary)" },
      });
      setFormKey((key) => key + 1);
    } catch (error) {
      toast.error(error?.response?.data?.message || t("Something went wrong"));
    }
  };

  return (
    <Page>
      <PageHeader
        title={t("Add Genre")}
        subtitle={t("Enable the content types this genre applies to")}
      />
      <GenreForm
        key={formKey}
        rows={initialRows()}
        onSubmit={handleSubmit}
        submitLabel={t("submit")}
      />
    </Page>
  );
};

export default AddGenre;
